import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../../../core/services/api/api.service';
import { Metrics } from '../../../models/metrics';
import { UnansweredQuestion } from '../../../models/unanswered-question';
import { StudyType } from '../../../models/study-type';
import { Filter } from '../../../models/filter';

@Injectable({
  providedIn: 'root',
})
export class MetricsService {
  getResponsesForMetrics(studyId: number, interventionId = 0, moduleId = 0): Observable<Metrics> {
    return this.apiService.get<Metrics>(`/dashboard/responses/${studyId}/${interventionId}/${moduleId}`);
  }

  getFilterValues(studyId: number): Observable<Filter> {
    return this.apiService.get<Filter>(`/dashboard/study/${studyId}/metrics`);
  }

  getUnansweredQuestionsForMetrics(
    studyId: number,
    interventionId = 0,
    moduleId = 0
  ): Observable<UnansweredQuestion[]> {
    return this.apiService.get<UnansweredQuestion[]>(
      `/dashboard/responses/${studyId}/${interventionId}/${moduleId}/seen/en`
    );
  }

  getParticipantResponsesForScreening(studyId: number, participantId: number): Observable<Metrics> {
    return this.apiService.get<Metrics>(`/dashboard/study/${studyId}/participant/${participantId}/responses`);
  }

  downloadInterventionAnswers(
    languageCode: string,
    interventionId: number,
    version: string,
  ): Observable<any> {

    return this.apiService.get(
      `/export/study/language/${languageCode}/metrics/${interventionId}/${version}`,
      { responseType: 'text/csv' }
    );
  }

  downloadInterventionAnswersTiming(interventionId: number): Observable<any> {
    return this.apiService.get(`/export/intervention/${interventionId}`, { responseType: 'text/csv' });
  }

  downloadInterventionFiles(
    keyForFiles: string,
    studyId: number,
    interventionId: number,
    moduleId: number
  ): Observable<any> {
    return this.apiService.get(
      `/dashboard/study/${studyId}/intervention/${interventionId}/module/${moduleId}/${keyForFiles}`,
      { responseType: 'arraybuffer' }
    );
  }

  downloadInterventionParticipantData(interventionId: number, participantId: number): Observable<any> {
    return this.apiService.get(`/dashboard/participant-metrics-pdf/${interventionId}/${participantId}`, { responseType: 'arraybuffer'});
  }

  constructor(private apiService: ApiService) {}
}
